import TaContactPersonModal from './TaContactPersonModal'

export default TaContactPersonModal
